import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import template from './has-operators-filter.hbs'
import dropdown from 'scoreboard/components/dropdown'
import operatorOptions from 'scoreboard/datasets/filters/operator-options'
import renderValuesSelect from 'scoreboard/datasets/filters/render-values-select'
import arrayToHash from 'scoreboard/components/array-to-hash'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER } = DataType

const operatorsWithValues = ['contains-any','contains-all','does-not-contain-any',
	'does-not-contain-all','is-any','is-not-any','in-any-period']

const HasOperatorsFilter = Backbone.View.extend({

	className: 'report-filters filter',

	events: {
		'change select.operator-type': '_onChangeOperator',
		'change select.values': '_onChangeValues'
	},

	/**
	 * @param {Object} options.data the object holding the data for the filter
	 * @param {Object} options.allowedOperators hash of allowed operators
	 * @param {String} [options.operatorName='operator'] the name use for the select that holds the operators
	 * @param {String} [options.valuesName='values'] the name use for the select that holds the values to suggest
	 * @param {Array} [options.operatorsWithValues] array of the operators that denote to use the values select
	 */
	initialize: function(options = {}) {
		this.options = options
		this.data = _.cloneDeep(options.data)

		this.options.operatorLabel = this.options.operatorLabel || 'datasets.filters.type'
		this.options.operatorName = this.options.operatorName || 'operator'
		this.options.valuesName = this.options.valuesName || 'values'
		this.options.operatorsWithValues = arrayToHash(this.options.operatorsWithValues || operatorsWithValues, _.identity)
	},

	render: function() {
		this.$el.html(template(this.options))

		//populate the operator dropdown
		let opts = this.options.operatorOptions || {}
		const dataType = this.options.isScorecardScore ?
			NUMBER : this.options.dataType
		let operators = _.cloneDeep(operatorOptions({ dataType }, opts))

		//certain filters only allow certain operators
		if (!_.isNil(this.options.allowedOperators)) {
			let allowed = arrayToHash(this.options.allowedOperators, _.identity)
			_.each(operators, (val, key) => {
				//remove the ones that aren't allowed
				if (!allowed[key]) {
					delete operators[key]
				}
			})
		}

		//certain filters specific additional operators
		if (!_.isNil(this.options.additionalOperators)) {
			let additional = this.options.additionalOperators
			if (_.isArray(this.options.additionalOperators)) {
				additional = arrayToHash(this.options.additionalOperators, _.identity)
			}
			_.each(additional, (val, key) => {
				if (!operators[key]) {
					operators[key] = val
				}
			})
		}

		dropdown.object(this._operatorSelect().empty(), operators, this.data[this.options.operatorName])

		//sub views can render additional controls
		this._renderAdditionalControls()

		//initialize the controls based of the current operator
		this._onChangeOperator()

		return this
	},

	_renderAdditionalControls: function() {
		//subview may implement this to add in additional controls to the view
	},

	_renderValuesSelect: function() {
		if (this._isHidingValues()) { return }

		let el = this._valuesSelect().removeClass('is-not-displayed')
		let operator = this._operatorSelect().val()

		renderValuesSelect({
			el,
			operator,
			values: _.map(this.data[this.options.valuesName], v => v.toString()),
			suggestions: this.options.seedData,
			dataType: this.options.dataType,
			valueFormatter: this._formatValue && this._formatValue.bind(this),
			valueConverter: this._convertValue && this._convertValue.bind(this)
		})

		if (!this._valuesMarkedField) {
			this._valuesMarkedField = new MarkedField({
				el,
				validator: requiredValidator
			}).render()
		} else {
			this._valuesMarkedField.clearError()
		}
	},

	// No implementation; For overrides only.
	_formatValue: null,
	// No implementation; For overrides only.
	_convertValue: null,

	_onChangeOperator: function(e) {
		let operatorValue =  this._operatorSelect().val()
		this.data[this.options.operatorName] = operatorValue
		//toggle the control based on the operator
		_.each(this.$(`.control`), el => {
			let control = $(el)
			let hideControl = !control.hasClass(operatorValue)
			control.toggleClass('is-not-displayed', hideControl)
		})

		this._renderValuesSelect()
		this.trigger('operator', operatorValue)
	},

	_onChangeValues: function() {
		this.data[this.options.valuesName] = this._valuesSelect().val()
	},

	_operatorSelect: function() {
		return this.$(`select[name=${this.options.operatorName}]`)
	},

	_valuesSelect: function() {
		return this.$(`select[name=${this.options.valuesName}]`)
	},

	/**
	 * Provides validation to this view
	 */
	test: function() {
		if (!this._isHidingValues()) {
			return this._valuesMarkedField.test()
		}
		return null
	},

	_isHidingValues: function() {
		return _.isNil(this.options.operatorsWithValues[this._operatorSelect().val()])
	},

	//returns the data captured by this filter
	gather: function(e) {
		return this.data
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._valuesMarkedField], 'remove')
	}

})

export default HasOperatorsFilter

HasOperatorsFilter.__filename__ = 'reports/common/filter/has-operators-filter.js'
